// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".date-badges[data-v-1557396a]{background:rgba(0,0,0,.871);border-radius:5px;height:80%}.loading[data-v-1557396a]{background-color:rgba(0,0,0,.3)}.bg-orange[data-v-1557396a]{background-color:orange}.bg-orange[data-v-1557396a],.bg-red[data-v-1557396a]{padding-top:3px;width:100vw}.bg-red[data-v-1557396a]{background-color:#f63f32}.bg-green[data-v-1557396a]{background-color:#7bbb5d;padding-top:3px;width:100vw}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
